export default __webpack_public_path__ + "static/media/moon.5c99433b.svg";